import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class RentPaymentService {
  static getRoads = () => api.get(urls.RENT_PAYMENT.GET_ROADS);

  static registerApplication = data => api.post(urls.WORKFLOW.REGISTER_APPLICATION, data);

  static fetchRentPaymentApplication = id => api.get(urls.RENT_PAYMENT.FETCH_APPLICATION_RENT_PAYMENT, id);

  static saveApplication = payload => api.post(urls.RENT_PAYMENT.SAVE_APPLICATION_RENT_PAYMENT, payload);

  static checkoutApplication = id => api.post(urls.RENT_PAYMENT.CHECKOUT_APPLICATION_RENT_PAYMENT + '/' + id);

  static PaymentBreakDown = id => api.get(urls.RENT_PAYMENT.PAYMENT_BREAKDOWN, id);

  static getApplicationContractPDF = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.RENT_PAYMENT.DOWNLOAD_CONTRACT_PDF, appId);
  };

  static getApplicationTitleDeedPDF = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.RENT_PAYMENT.DOWNLOAD_TITLE_DEED_PDF, appId);
  };
}

export default RentPaymentService;
